<template>
    <div class="animate-moveFromBottom animate-delay180">
        <v-chip @click="$emit('start',text)" v-for="text in ArrayPerLine" size="small" class="ma-1 mb-2">
            <span style="margin-top:1px">{{text}}</span>
        </v-chip>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

defineEmits<{ start: [text: string] }>()

const { assistant } = storeToRefs(useGlobalsStore())

const ArrayPerLine = computed(() => {
    if (assistant.value.config.starters.length > 0) {
        return assistant.value.config.starters.split('\n')
    } else {
        return []
    }
})
</script>
<style>

</style>
